module.exports = __webpack_public_path__ + "media/60.2c4cd934.mp3";